import {useParams} from "react-router-dom";
import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminContract from "../../../components/admin/client/contract/AdminContract";

//계약 상세 페이지
const AdminContractInfoPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //계약 식별자가 없는 경우
    if (!id) {
        return <div>Invalid project ID</div>;
    }

    return (
        <AdminLayout>
            {/*계약 상세 페이지 버튼*/}
            <AdminContract contractId={parseInt(id)}/>
        </AdminLayout>
    )
}
export default AdminContractInfoPage;